import React, { useState, useContext } from "react";
import AddCommand from "../Commands/AddCommand/AddCommand";
import ValidationCommand from "../Commands/ValidationCommand/ValidationCommand";
import MiddleEditCommand from "../Commands/MiddleEditCommand/MiddleEditCommand";
import CloseCommand from "../Commands/CloseCommand/CloseCommand";
import DropDownListNew from "../DropDownList/DropDownListNew";
import SimpleDialog from "../SimpleDialog/SimpleDialog";
import { store } from "../../store.js";

export default function EditableDropDownList (props)  {
  const globalState = useContext(store);
  const [action, setAction] = useState({isClick:false, operation:"", type:props.type});

   const onClickOperation = (e, operation) => {
    if(e) e.preventDefault(); 
    var updatedAction = JSON.parse(JSON.stringify(action));
    updatedAction.isClick = true;
    updatedAction.operation = operation;
    setAction(updatedAction);
  }

  const onClose = () => {
    var updatedAction = JSON.parse(JSON.stringify(action));
    updatedAction.isClick = false;
    setAction(updatedAction);
  }

  const canShowDialog = () => {
    
    return action.isClick && document.getElementById(props.id) != null
  }

  return (
    <div style ={{ display: "flex", marginRight: "5px"}} onClick={(e) => {e.stopPropagation() }}>
        <div id={props.id} style ={{ fontSize:"14px", marginTop: "4px", marginRight: "5px", fontWeight:"bold", fontFamily:"sans-serif" }}> 
          {props.title} 
        </div>
        <div id={props.id} style ={{ width: props.width, marginTop: "-3px"}}>
        <DropDownListNew
          currentData={props.currentData}
          initialValue={props.initialValue}
          id={"List" + props.id}
          onDropDownItemClick={(itemSelected) => props.onDropDownItemClick(itemSelected)}
          onlyLabel={false}
          fontFamily={props.style.fontFamily}
          fontSize={props.style.fontSize}
          fontWeight={props.style.fontWeight}
          color={props.style.color}
          minWidth={props.width}
        />
        </div>

        {props.policy.canAdd && <div onClick={(e) => onClickOperation(e, globalState.state.formData.menu.operation.Add) } style ={{ marginLeft: "-10px" }}>
          <AddCommand className ="hoverGreen"/>
        </div>}
        {props.policy.canEdit && <div onClick={(e) => onClickOperation(e, globalState.state.formData.menu.operation.Update) } style ={{ marginLeft: "5px" }}>
          <MiddleEditCommand className ="hoverBlue"/>
        </div>}
        {props.policy.canDelete &&  <div onClick={(e) => onClickOperation(e, globalState.state.formData.menu.operation.Delete) } style ={{ marginLeft: "-2px" }}>
          <CloseCommand className ="hoverRed"/>
        </div>}
        
        {canShowDialog() && <SimpleDialog changeModeRequired ={false} onClickValid ={(e, detail) => props.onClickValid(e, detail)}
        onClose = {() => onClose()}  value = {action.operation == globalState.state.formData.menu.operation.Add ? "" : props.initialValue}
        parentId = {props.id} type = {action.type} operation = {action.operation}/>}
        
    </div>
  );
  //
}

